import { render, staticRenderFns } from "./forwardDailog.vue?vue&type=template&id=679d5025&scoped=true&"
import script from "./forwardDailog.vue?vue&type=script&lang=js&"
export * from "./forwardDailog.vue?vue&type=script&lang=js&"
import style0 from "./forwardDailog.vue?vue&type=style&index=0&id=679d5025&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d5025",
  null
  
)

export default component.exports